module.exports = __webpack_public_path__ + "img/user-btn.c0281657.svg";